


























































import Vue from 'vue';
import Component from 'vue-class-component';
import { ValidationObserver } from 'vee-validate';
import { Ref } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import { UseService } from '@/services/service';
import NotifyStaffService from '@/services/notify-staff.service';
import templateMixin from './templateMixin';

@Component<SloganAnswerTemplate>({
  mixins: [templateMixin],
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class SloganAnswerTemplate extends Vue {
  currentStaff!: StaffEntity;

  @Ref('refForm')
  refForm: InstanceType<typeof ValidationObserver>;

  close: () => void;

  message = '';

  flag = true;

  isCorrect = false;

  isHiddenBtnSubmit = false;

  @UseService(NotifyStaffService)
  notifyStaffService: NotifyStaffService;

  get getErrorMessage() {
    let correctAnswer = this.currentStaff.company.messageEn;
    switch (this.$i18n.locale) {
      case 'vi':
        correctAnswer = this.currentStaff.company.messageVi;
        break;
      case 'ja':
        correctAnswer = this.currentStaff.company.messageJa;
        break;
      default:
        break;
    }
    return this.$t('sloganAnswer.errorMessage', { correctAnswer }) as string;
  }

  async submit() {
    this.flag = true;
    this.isCorrect = false;

    switch (this.$i18n.locale) {
      case 'vi':
        if (this.compareText(this.message, this.currentStaff.company.messageVi) !== 0)
          this.flag = false;
        break;
      case 'ja':
        if (this.compareText(this.message, this.currentStaff.company.messageJa) !== 0)
          this.flag = false;
        break;
      default:
        if (this.compareText(this.message, this.currentStaff.company.messageEn) !== 0)
          this.flag = false;
        break;
    }
    if (!this.flag) {
      this.refForm.setErrors({ message: this.getErrorMessage });
      return;
    }
    this.isCorrect = true;
    this.isHiddenBtnSubmit = true;
    const currentNotify = JSON.parse(JSON.stringify(this.$attrs.currentNotify));
    this.notifyStaffService.readNotify(currentNotify.staff_id, currentNotify.notify_id);
    console.log(true);
  }

  compareText(text1: string, text2: string): number {
    return this.replaceSpecifyLine(text1.toLowerCase()).localeCompare(
      this.replaceSpecifyLine(text2.toLowerCase()),
    );
  }

  replaceSpecifyLine(text: string): string {
    return text.replace(/\n|\r|\t|\\a|\\b/g, ' ');
  }
}
